// extracted by mini-css-extract-plugin
export default {"supportButton":"SupportIcon_supportButton__2Xx4G","badge":"SupportIcon_badge__zJVjq"};